import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
    Typography: {
      textAlign: 'center',
      justifyContent:'center',
      fontSize: '0.8em',
      display:'flex',
      width:'9em'
        // fontWeight: 300
    },
    Typography2: {
      textAlign: 'center',
      justifyContent:'center',
      fontSize: 30,
      display:'flex',
      // width:'75%',
      color:'black',
      '@media only screen and (max-width: 959px)': {
        width:'100%',
        fontSize: 20,
      },
      // fontWeight: 300
    },
    ratingStartMain:{
      display:'flex',
      justifyContent:'center',
      alignContent:'center',
      alignItems:'center',
      padding:40,
      '@media only screen and (max-width: 959px)': {
        padding:10,
      },
    },
    box:{
      '@media only screen and (max-width: 959px)': {
        paddingLeft:'0em'
      },
      '@media only screen and (max-width: 575px)': {
        paddingLeft:'0em'
      },
      paddingLeft:'-3em'
     
    },
    smallRatingMain:{
      paddingTop:'0.3em'
    },
    rating:{
        justifyContent:'center',
        alignItems:'center',
        // paddingRight:70,
        '@media only screen and (max-width: 959px)': {
          // paddingLeft:70,
        },
        '&.MuiRating-sizeLarge':{
            fontSize:'2.875rem',
            '@media only screen and (max-width: 959px)': {
              fontSize:'1.875rem',
            },
        }
    }
      
});
export default function SimpleRating(props:any) {
    const classes = useStyles();
  const [value, setValue] = React.useState<number | null>(5);

  return (
   <div className={classes.smallRatingMain}>
     {props.reviewText ?
      <Box component="fieldset" mb={3} borderColor="transparent" >
        <Rating
          readOnly 
          name="simple-controlled"
          value={value}
          onChange={(_event: any, newValue: any) => {
            setValue(newValue);
          }}
        />
        <Typography className={classes.Typography}>{props.reviewText}</Typography>
      </Box>  :  
      <div className={classes.ratingStartMain}>
         <Box component="fieldset" mb={3} borderColor="transparent" className={classes.box}>
           <Rating
             readOnly 
             name="size-large"
             size="large"
             value={value}
             onChange={(_event: any, newValue: any) => {
               setValue(newValue);
             }}
             className={classes.rating}
           />
           <Typography className={classes.Typography2}>Reviews</Typography>
         </Box>  
      </div>}
   </div>
  );
}
